// extracted by mini-css-extract-plugin
export var carrierNotice = "_lk-5";
export var carrierNoticePlaceholder = "_lk-6";
export var deliveryRow = "_lk-c";
export var fixedHeight = "_lk-4";
export var freightLogo = "_lk-b";
export var fullWidth = "_lk-3";
export var priceColumn = "_lk-7";
export var radioSelected = "_lk-9";
export var radioUnselected = "_lk-8";
export var selectedOption = "_lk-2";
export var selectedOptionContainer = "_lk-1";
export var selection = "_lk-0";
export var tallSkeletonText = "_lk-a";